type Env = 'development' | 'testing' | 'staging' | 'production'

interface Config {
  ACCOUNT_SERVICE_URL: string
  APP_ENV: Env
  APPOINTMENT_SERVICE_URL_EU: string
  APPOINTMENT_SERVICE_URL_NA: string
  AUTH0_AUDIENCE: string
  AUTH0_CLIENT_ID: string
  AUTH0_DOMAIN: string
  CONSULTANT_SERVICE_URL_EU: string
  CONSULTANT_SERVICE_URL_NA: string
  CUSTOMER_PROFILE_SERVICE_URL_EU: string
  CUSTOMER_PROFILE_SERVICE_URL_NA: string
  CUSTOMER_SERVICE_URL_EU: string
  CUSTOMER_SERVICE_URL_NA: string
  FORCE_ENABLED_FEATURE_FLAGS: { name: string; value: number | boolean }[]
  IS_LIVE_ENVIRONMENT: boolean
  LAUNCH_DARKLY_CLIENT_ID: string
  LOGROCKET_PROJECT_ID: string
  MIXPANEL_PROJECT_TOKEN: string
  PROVIDER_RECOMMENDATION_SERVICE_URL_EU: string
  PROVIDER_RECOMMENDATION_SERVICE_URL_NA: string
  OPPORTUNITY_SERVICE_URL_EU: string
  OPPORTUNITY_SERVICE_URL_NA: string
  PARTNER_PORTAL_NEO_URL: string
  FLOW_CLIENT_URL: string
  PARTNER_SERVICE_URL_EU: string
  PARTNER_SERVICE_URL_NA: string
  REACT_QUERY_DEV_TOOLS_ENABLED: boolean
  SCHEDULING_V2_URL: string
  SYNCFUSION_LICENSE_KEY: string
  USER_SERVICE_URL_EU: string
  USER_SERVICE_URL_NA: string
}

const ACCOUNT_SERVICE_URL = process.env.REACT_APP_ACCOUNT_SERVICE_URL as string
const APP_ENV = process.env.REACT_APP_ENVIRONMENT as Env
const APPOINTMENT_SERVICE_URL_EU = process.env.REACT_APP_APPOINTMENT_SERVICE_URL_EU as string
const APPOINTMENT_SERVICE_URL_NA = process.env.REACT_APP_APPOINTMENT_SERVICE_URL_NA as string
const AUTH0_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE as string
const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID as string
const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN as string
const CONSULTANT_SERVICE_URL_EU = process.env.REACT_APP_CONSULTANT_SERVICE_URL_EU as string
const CONSULTANT_SERVICE_URL_NA = process.env.REACT_APP_CONSULTANT_SERVICE_URL_NA as string
const CUSTOMER_PROFILE_SERVICE_URL_EU = process.env.REACT_APP_CUSTOMER_PROFILE_SERVICE_URL_EU as string
const CUSTOMER_PROFILE_SERVICE_URL_NA = process.env.REACT_APP_CUSTOMER_PROFILE_SERVICE_URL_NA as string
const CUSTOMER_SERVICE_URL_EU = process.env.REACT_APP_CUSTOMER_SERVICE_URL_EU as string
const CUSTOMER_SERVICE_URL_NA = process.env.REACT_APP_CUSTOMER_SERVICE_URL_NA as string
const ENVIRONMENT = (process.env.REACT_APP_ENVIRONMENT ?? 'development') as Env

// REACT_APP_FORCE_ENABLED_FEATURE_FLAGS=FEATURE_FLAG_NAME_1,FEATURE_FLAG_NAME_2:WITH_VALUE
const FORCE_ENABLED_FEATURE_FLAGS =
  process.env.REACT_APP_FORCE_ENABLED_FEATURE_FLAGS?.split(',').map((flag) => {
    if (flag.includes(':')) {
      const [name, value] = flag.split(':')
      const actualValue = value === 'true' ? true : value === 'false' ? false : Number.isNaN(Number(value)) ? false : Number(value)

      return { name, value: actualValue }
    }

    return { name: flag, value: true }
  }) ?? []

const LAUNCH_DARKLY_CLIENT_ID = process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_ID as string
const LOGROCKET_PROJECT_ID = process.env.REACT_APP_LOGROCKET_PROJECT_ID as string
const MIXPANEL_PROJECT_TOKEN = process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN as string
const PROVIDER_RECOMMENDATION_SERVICE_URL_EU = process.env.REACT_APP_PROVIDER_RECOMMENDATION_SERVICE_URL_EU as string
const PROVIDER_RECOMMENDATION_SERVICE_URL_NA = process.env.REACT_APP_PROVIDER_RECOMMENDATION_SERVICE_URL_NA as string
const OPPORTUNITY_SERVICE_URL_EU = process.env.REACT_APP_OPPORTUNITY_SERVICE_URL_EU as string
const OPPORTUNITY_SERVICE_URL_NA = process.env.REACT_APP_OPPORTUNITY_SERVICE_URL_NA as string
const PARTNER_PORTAL_NEO_URL = process.env.REACT_APP_PARTNER_PORTAL_NEO_URL as string
const FLOW_CLIENT_URL = process.env.REACT_APP_FLOW_CLIENT_URL as string
const PARTNER_SERVICE_URL_EU = process.env.REACT_APP_PARTNER_SERVICE_URL_EU as string
const PARTNER_SERVICE_URL_NA = process.env.REACT_APP_PARTNER_SERVICE_URL_NA as string
const SCHEDULING_V2_URL = process.env.REACT_APP_SCHEDULING_V2_URL as string
const REACT_QUERY_DEV_TOOLS_ENABLED = ['1', 'true'].includes(process.env.REACT_APP_REACT_QUERY_DEV_TOOLS_ENABLED ?? '')
const SYNCFUSION_LICENSE_KEY = process.env.REACT_APP_SYNCFUSION_LICENSE_KEY as string
const USER_SERVICE_URL_EU = process.env.REACT_APP_USER_SERVICE_URL_EU as string
const USER_SERVICE_URL_NA = process.env.REACT_APP_USER_SERVICE_URL_NA as string

const liveEnvironments: Env[] = ['testing', 'staging', 'production']
const isLiveEnvironment = liveEnvironments.includes(ENVIRONMENT as Env)

const config: Config = Object.freeze({
  ACCOUNT_SERVICE_URL,
  APP_ENV,
  APPOINTMENT_SERVICE_URL_EU,
  APPOINTMENT_SERVICE_URL_NA,
  AUTH0_AUDIENCE,
  AUTH0_CLIENT_ID,
  AUTH0_DOMAIN,
  CONSULTANT_SERVICE_URL_EU,
  CONSULTANT_SERVICE_URL_NA,
  CUSTOMER_PROFILE_SERVICE_URL_EU,
  CUSTOMER_PROFILE_SERVICE_URL_NA,
  CUSTOMER_SERVICE_URL_EU,
  CUSTOMER_SERVICE_URL_NA,
  FORCE_ENABLED_FEATURE_FLAGS,
  IS_LIVE_ENVIRONMENT: isLiveEnvironment,
  LAUNCH_DARKLY_CLIENT_ID,
  LOGROCKET_PROJECT_ID,
  MIXPANEL_PROJECT_TOKEN,
  PROVIDER_RECOMMENDATION_SERVICE_URL_EU,
  PROVIDER_RECOMMENDATION_SERVICE_URL_NA,
  OPPORTUNITY_SERVICE_URL_EU,
  OPPORTUNITY_SERVICE_URL_NA,
  PARTNER_PORTAL_NEO_URL,
  FLOW_CLIENT_URL,
  PARTNER_SERVICE_URL_EU,
  PARTNER_SERVICE_URL_NA,
  REACT_QUERY_DEV_TOOLS_ENABLED,
  SCHEDULING_V2_URL,
  SYNCFUSION_LICENSE_KEY,
  USER_SERVICE_URL_EU,
  USER_SERVICE_URL_NA,
})

export { config }
